import { graphql } from "@/lib/gql/__generated__";

export const HotelTemplateSettingsUpdateMutation = graphql(/* GraphQL */ `
	mutation HotelTemplateSettingsUpdate($input: HotelTemplateSettingsUpdateInput!) {
		hotelTemplateSettingsUpdate(input: $input) {
			userErrors
			hotelTemplateSettings {
				id
				hotelID
				hotelTemplateType
				hotelTemplateTypeSelectable
			}
		}
	}
`);
